<template>
    <div v-if="componentData" class="image-wrapper" :class=" {fullWidth : componentData.fullWidth} ">
        <SafeImage 
            :imageData="componentData.singleImage"
            :placeholder="PLACEHOLDER_IMAGES.GENERAL"
            placeholderText="Content image not available"
        />
    </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import SafeImage from '../SafeImage.vue'
import { PLACEHOLDER_IMAGES } from '../../composables/useImageErrorHandler'

export default defineComponent({
    components: {
        SafeImage
    },
    props:{
        componentData: {
            type: Object,
            required: false
        },
    },
    setup(props) {
        const homeurl: string = import.meta.env.VITE_API_URL;

        return {
            homeurl,
            PLACEHOLDER_IMAGES
        };
    }
})

</script>
